<!-- gsa-dashboard view -->
<div class="info-box" *ngIf="viewNumber == 0">
    <div class="perfil-box-dashboard">
        <div class="d-flex" style="padding: 20px;">
            <div class="m-r-15">
                <img class="round" [src]="store.logoUrl" width="36" *ngIf="store.logoUrl">
                <img src="store-icon.png" width="36" *ngIf="!store.logoUrl">
            </div>
            <div class="">
                <div class="font-b1 text-color" style="font-size: 20px;">
                    {{store.vendorName}}
                </div>
                <div class="font-c1 text-color">
                    {{store.storeName}}
                </div>
                <div class="font-c2 text-white m-t-8 font-bold" (click)="ongChangeStore()">
                    <i class="mdi mdi-login font-14 m-r-5"></i>
                    Cambiar lugar de canje
                </div>
            </div>
        </div>
    </div>

    <div class="p-20">
        <div class="d-flex-center font-16 font-bold">Escanear un código</div>
        <div class="d-flex-between m-t-10">
            <button class="btn btn-primary btn-scan" (click)="onNavigateToScan()" [ngStyle]="{'width': store.zebraScan ? '' : '100%'}">
                <i class="mdi mdi-qrcode-scan"></i> Escanear
            </button>
            <button *ngIf="store.zebraScan" class="btn btn-dark btn-scan" (click)="onNavigateToScanZebra()"><img src="assets/images/zebraIcon.png" width="18"> Zebra</button>
        </div>
    </div>
</div>

<!-- gsa-account view -->
<div class="perfil-box m-b-20" *ngIf="viewNumber == 1">
    <div class="text-center">
        <img class="round" [src]="store.logoUrl" width="36" *ngIf="store.logoUrl">
        <img src="store-icon.png" width="36" *ngIf="!store.logoUrl">

        <div class="font-b1 text-color"> {{store.vendorName}}</div>

        <div class="font-c1 text-color">
            {{store.storeName}}
        </div>
    </div>
</div>
